export default __webpack_public_path__ + "static/media/banco-santander-logo.546d615c.svg";